
import HomeMain from '../components/Home/HomeMain'
import CardInfo from '../components/CardInfo'
import HomeProducts from '../components/Home/HomeProducts'
import HomeSustain from '../components/Home/HomeSustain'
import HomeCertificate from '../components/Home/HomeCertificate'
import HomeFooterCard from '../components/Home/HomeFooterCard'
export default {
  components: {
    HomeMain,
    CardInfo,
    HomeProducts,
    HomeSustain,
    HomeCertificate,
    HomeFooterCard
  },
  mounted () {

  },
  data () {
    return {
      subTitle: 'Advance Fiber Co., Ltd. was established to exclusively produce and distribute Medium Density Fiberboard (MDF).',
      info: 'Driven by our 3 core values of honesty, respect and sustainability, we have been on a mission since then. From our humble beginnings we are now one of the major producers of MDF and related products on the region.'
    }
  }

}
